import React, { useState, useEffect } from 'react'
import { Panel, Form, ControlLabel, Grid, Row, Col, Input, Radio, RadioGroup } from 'rsuite'
import classNames from 'classnames'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import CKEditorFrom from '../../../components/forms/input/CKEditorFrom'
import { isRequired, isValidators, isRequiredFiled } from '../../../utils/ValidatorUtils'
import CustomAlertMessageInfo from '../../CustomAlertMessageInfo'

export default function GranteeProperty({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
}) {
  const [schema, setSchema] = useState(_schema)
  console.log('3333 => ', schema.forms.property.partThree.jobAbandonerRadio.options[0].label)
  const [radio, setRadio] = useState(
    schema.forms.property.partOne.grantRadio['value']
      ? schema.forms.property.partOne.grantRadio['value']
      : '0'
  )

  const [radio2, setRadio2] = useState(
    schema.forms.property.partOne.areaRadio['value']
      ? schema.forms.property.partOne.areaRadio['value']
      : '0'
  )

  const [radio3, setRadio3] = useState(
    schema.forms.property.partTwo.experienceRadio['value']
      ? schema.forms.property.partTwo.experienceRadio['value']
      : '0'
  )

  const [jobAbandonerRadio, setJobAbandonerRadio] = useState(
    schema.forms.property.partThree.jobAbandonerRadio['value']
      ? schema.forms.property.partThree.jobAbandonerRadio['value']
      : '1'
  )

  const [capitalCorruptionRadio, setCapitalCorruptionRadio] = useState(
    schema.forms.property.partThree.capitalCorruptionRadio['value']
      ? schema.forms.property.partThree.capitalCorruptionRadio['value']
      : '1'
  )

  const [wrongConditionRadio, setWrongConditionRadio] = useState(
    schema.forms.property.partThree.wrongConditionRadio['value']
      ? schema.forms.property.partThree.wrongConditionRadio['value']
      : '1'
  )

  const [objectiveRadio, setObjectiveRadio] = useState(
    schema.forms.property.partThree.objectiveRadio['value']
      ? schema.forms.property.partThree.objectiveRadio['value']
      : '1'
  )

  const [objBusinessRadio, setObjBusinessRadio] = useState(
    schema.forms.property.partThree.objBusinessRadio['value']
      ? schema.forms.property.partThree.objBusinessRadio['value']
      : '1'
  )

  const radioGroupWidthStyle = {
    width: '100%',
  }
  const marginTopStyle = {
    marginTop: '0.5%',
  }

  return (
    <div>
      <Panel collapsible defaultExpanded bodyFill>
        <Grid fluid>
          <Form fluid>
            {schema.forms.property.description && (
              <div style={{ marginBottom: 10 }}>
                <CustomAlertMessageInfo contents={schema.forms.property.description} />
              </div>
            )}
            <Panel header={schema.forms.property.partOne.subjectName}>
              <Grid fluid>
                <div
                  dangerouslySetInnerHTML={{
                    __html: schema.forms.property.partOne.grantRadio['label'],
                  }}
                ></div>

                <Controller
                  name={schema.forms.property.partOne.grantRadio['name']}
                  control={control}
                  defaultValue={radio}
                  render={(props) => {
                    return (
                      <RadioGroup
                        style={radioGroupWidthStyle}
                        value={props.value}
                        inline
                        onChange={(e) => {
                          props.onChange(e)
                          setRadio(e)
                        }}
                      >
                        <Radio value="0">
                          {schema.forms.property.partOne.grantRadio.options[0].label}
                        </Radio>
                        <Row>
                          <Col xs={24} sm={24} md={8} lg={5}>
                            <Radio value="1">
                              {schema.forms.property.partOne.grantRadio.options[1].label}
                            </Radio>
                          </Col>
                          {radio == '1' && (
                            <Col xs={24} sm={24} md={24} lg={19}>
                              <Row style={{ marginTop: '8px' }}>
                                <Col xs={24} md={6}>
                                  <ControlLabel>
                                    {isRequiredFiled(
                                      isRequired(
                                        schema.forms.property.partOne.inputProject.validators
                                      ),
                                      schema.forms.property.partOne.inputProject.label
                                    )}
                                  </ControlLabel>
                                </Col>
                                <Col xs={24} md={12}>
                                  <ErrorMessage
                                    error={errors[schema.forms.property.partOne.inputProject.name]}
                                  />
                                  <Input
                                    name={schema.forms.property.partOne.inputProject.name}
                                    defaultValue={schema.forms.property.partOne.inputProject.value}
                                    inputRef={register(
                                      isValidators(
                                        schema.forms.property.partOne.inputProject.validators
                                      )
                                    )}
                                  />
                                </Col>
                              </Row>
                              <Row style={{ marginTop: '15px' }}>
                                <Col xs={24} md={6}>
                                  <ControlLabel>
                                    {isRequiredFiled(
                                      isRequired(
                                        schema.forms.property.partOne.inputAmountProject.validators
                                      ),
                                      schema.forms.property.partOne.inputAmountProject.label
                                    )}
                                  </ControlLabel>
                                </Col>
                                <Col xs={24} md={12}>
                                  <ErrorMessage
                                    error={
                                      errors[schema.forms.property.partOne.inputAmountProject.name]
                                    }
                                  />
                                  <Input
                                    name={schema.forms.property.partOne.inputAmountProject.name}
                                    defaultValue={
                                      schema.forms.property.partOne.inputAmountProject.value
                                    }
                                    inputRef={register(
                                      isValidators(
                                        schema.forms.property.partOne.inputAmountProject.validators
                                      )
                                    )}
                                  />
                                </Col>
                              </Row>
                            </Col>
                          )}
                        </Row>
                      </RadioGroup>
                    )
                  }}
                />
                <br />
                <br />
                <div
                  dangerouslySetInnerHTML={{
                    __html: schema.forms.property.partOne.areaRadio['label'],
                  }}
                ></div>
                <Controller
                  name={schema.forms.property.partOne.areaRadio['name']}
                  control={control}
                  defaultValue={radio2}
                  render={(props) => {
                    return (
                      <RadioGroup
                        style={radioGroupWidthStyle}
                        value={props.value}
                        inline
                        onChange={(e) => {
                          props.onChange(e)
                          setRadio2(e)
                        }}
                      >
                        <Radio value="0">
                          {schema.forms.property.partOne.areaRadio.options[0].label}
                        </Radio>
                        <Row>
                          <Col xs={24} sm={8} md={8} lg={5}>
                            <Radio value="1">
                              {schema.forms.property.partOne.areaRadio.options[1].label}
                            </Radio>
                          </Col>
                          {radio2 == '1' && (
                            <Col xs={24} sm={24} md={24} lg={19}>
                              <Row style={{ marginTop: '8px' }}>
                                <Col xs={24} md={6}>
                                  <ControlLabel>
                                    {isRequiredFiled(
                                      isRequired(
                                        schema.forms.property.partOne.inputArea.validators
                                      ),
                                      schema.forms.property.partOne.inputArea.label
                                    )}
                                  </ControlLabel>
                                </Col>
                                <Col xs={24} md={12}>
                                  <ErrorMessage
                                    error={errors[schema.forms.property.partOne.inputArea.name]}
                                  />
                                  <Input
                                    name={schema.forms.property.partOne.inputArea.name}
                                    defaultValue={schema.forms.property.partOne.inputArea.value}
                                    inputRef={register(
                                      isValidators(
                                        schema.forms.property.partOne.inputArea.validators
                                      )
                                    )}
                                  />
                                </Col>
                              </Row>
                              <Row style={{ marginTop: '15px' }}>
                                <Col xs={24} md={6}>
                                  <ControlLabel>
                                    {isRequiredFiled(
                                      isRequired(
                                        schema.forms.property.partOne.inputAmountArea.validators
                                      ),
                                      schema.forms.property.partOne.inputAmountArea.label
                                    )}
                                  </ControlLabel>
                                </Col>
                                <Col xs={24} md={12}>
                                  <ErrorMessage
                                    error={
                                      errors[schema.forms.property.partOne.inputAmountArea.name]
                                    }
                                  />
                                  <Input
                                    name={schema.forms.property.partOne.inputAmountArea.name}
                                    defaultValue={
                                      schema.forms.property.partOne.inputAmountArea.value
                                    }
                                    inputRef={register(
                                      isValidators(
                                        schema.forms.property.partOne.inputAmountArea.validators
                                      )
                                    )}
                                  />
                                </Col>
                              </Row>
                            </Col>
                          )}
                        </Row>
                      </RadioGroup>
                    )
                  }}
                />
              </Grid>
            </Panel>

            <Panel header={schema.forms.property.partTwo.subjectName}>
              <div
                dangerouslySetInnerHTML={{
                  __html: schema.forms.property.partTwo.experienceRadio['label'],
                }}
              ></div>
              <Controller
                name={schema.forms.property.partTwo.experienceRadio['name']}
                control={control}
                defaultValue={radio3}
                render={(props) => {
                  return (
                    <RadioGroup
                      style={radioGroupWidthStyle}
                      value={props.value}
                      inline
                      onChange={(e) => {
                        props.onChange(e)
                        setRadio3(e)
                      }}
                    >
                      <Radio value="0">
                        {schema.forms.property.partTwo.experienceRadio.options[0].label}
                      </Radio>
                      <Row>
                        <Col xs={24} sm={8} md={8} lg={3}>
                          <Radio value="1">
                            {schema.forms.property.partTwo.experienceRadio.options[1].label}
                          </Radio>
                        </Col>
                        {radio3 == '1' && (
                          <Col xs={24} sm={24} md={24} lg={18}>
                            <Row style={{ marginTop: '8px' }}>
                              <Col xsHidden xs={6}>
                                <ControlLabel>
                                  {isRequiredFiled(
                                    isRequired(
                                      schema.forms.property.partTwo.inputExperience.validators
                                    ),
                                    schema.forms.property.partTwo.inputExperience.label
                                  )}
                                </ControlLabel>
                              </Col>
                              <Col xs={12}>
                                <ErrorMessage
                                  error={errors[schema.forms.property.partTwo.inputExperience.name]}
                                />
                                <Input
                                  name={schema.forms.property.partTwo.inputExperience.name}
                                  defaultValue={schema.forms.property.partTwo.inputExperience.value}
                                  inputRef={register(
                                    isValidators(
                                      schema.forms.property.partTwo.inputExperience.validators
                                    )
                                  )}
                                />
                              </Col>
                            </Row>
                          </Col>
                        )}
                      </Row>
                    </RadioGroup>
                  )
                }}
              />
            </Panel>

            <Panel header={schema.forms.property.partThree.subjectName}>
              <Row>
                <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 7 }}>
                  <p>{schema.forms.property.partThree.jobAbandonerRadio['label']}</p>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Controller
                    name={schema.forms.property.partThree.jobAbandonerRadio['name']}
                    control={control}
                    defaultValue={jobAbandonerRadio}
                    render={(props) => {
                      return (
                        <RadioGroup
                          value={props.value}
                          inline
                          onChange={(e) => {
                            props.onChange(e)
                            setJobAbandonerRadio(e)
                          }}
                        >
                          <Radio value="0">
                            {schema.forms.property.partThree.jobAbandonerRadio.options[0].label}
                          </Radio>
                          <Radio value="1">
                            {schema.forms.property.partThree.jobAbandonerRadio.options[1].label}
                          </Radio>
                        </RadioGroup>
                      )
                    }}
                  />
                </Col>
              </Row>

              <Row>
                <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 7 }}>
                  <p>{schema.forms.property.partThree.capitalCorruptionRadio['label']}</p>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Controller
                    name={schema.forms.property.partThree.capitalCorruptionRadio['name']}
                    control={control}
                    defaultValue={capitalCorruptionRadio}
                    render={(props) => {
                      return (
                        <RadioGroup
                          value={props.value}
                          inline
                          onChange={(e) => {
                            props.onChange(e)
                            setCapitalCorruptionRadio(e)
                          }}
                        >
                          <Radio value="0">
                            {
                              schema.forms.property.partThree.capitalCorruptionRadio.options[0]
                                .label
                            }
                          </Radio>
                          <Radio value="1">
                            {
                              schema.forms.property.partThree.capitalCorruptionRadio.options[1]
                                .label
                            }
                          </Radio>
                        </RadioGroup>
                      )
                    }}
                  />
                </Col>
              </Row>

              <Row>
                <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 7 }}>
                  <p>{schema.forms.property.partThree.wrongConditionRadio['label']}</p>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Controller
                    name={schema.forms.property.partThree.wrongConditionRadio['name']}
                    control={control}
                    defaultValue={wrongConditionRadio}
                    render={(props) => {
                      return (
                        <RadioGroup
                          value={props.value}
                          inline
                          onChange={(e) => {
                            props.onChange(e)
                            setWrongConditionRadio(e)
                          }}
                        >
                          <Radio value="0">
                            {schema.forms.property.partThree.wrongConditionRadio.options[0].label}
                          </Radio>
                          <Radio value="1">
                            {schema.forms.property.partThree.wrongConditionRadio.options[1].label}
                          </Radio>
                        </RadioGroup>
                      )
                    }}
                  />
                </Col>
              </Row>

              <Row>
                <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 7 }}>
                  <p>{schema.forms.property.partThree.objectiveRadio['label']}</p>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Controller
                    name={schema.forms.property.partThree.objectiveRadio['name']}
                    control={control}
                    defaultValue={objectiveRadio}
                    render={(props) => {
                      return (
                        <RadioGroup
                          value={props.value}
                          inline
                          onChange={(e) => {
                            props.onChange(e)
                            setObjectiveRadio(e)
                          }}
                        >
                          <Radio value="0">
                            {schema.forms.property.partThree.objectiveRadio.options[0].label}
                          </Radio>
                          <Radio value="1">
                            {schema.forms.property.partThree.objectiveRadio.options[1].label}
                          </Radio>
                        </RadioGroup>
                      )
                    }}
                  />
                </Col>
              </Row>

              <Row>
                <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 7 }}>
                  <p>{schema.forms.property.partThree.objBusinessRadio['label']}</p>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Controller
                    name={schema.forms.property.partThree.objBusinessRadio['name']}
                    control={control}
                    defaultValue={objBusinessRadio}
                    render={(props) => {
                      return (
                        <RadioGroup
                          value={props.value}
                          inline
                          onChange={(e) => {
                            props.onChange(e)
                            setObjBusinessRadio(e)
                          }}
                        >
                          <Radio value="0">
                            {schema.forms.property.partThree.objBusinessRadio.options[0].label}
                          </Radio>
                          <Radio value="1">
                            {schema.forms.property.partThree.objBusinessRadio.options[1].label}
                          </Radio>
                        </RadioGroup>
                      )
                    }}
                  />
                </Col>
              </Row>
            </Panel>
          </Form>
        </Grid>
      </Panel>
    </div>
  )
}
